'use es6';

import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
const BASE_API_PATH = 'collector/v3/data-query/definitions';
/**
 *  GET designmanager/v1/raw-assets/:rawAssetId
 */

export function fetchGraphQLFiles() {
  return http.get(`${BASE_API_PATH}/`, {
    query: {
      portalId: PortalIdParser.get()
    }
  });
}